import React from "react";
import PropTypes from "prop-types";

import Button from "components/common/Button";

function UpdatePaymentStatusButton({ onUpdate = null, isLoading = false, className = "" }) {
  const handleClick = () => {
    if (onUpdate) {
      onUpdate();
    }
  };

  return (
    <Button
      variant="contained"
      size="large"
      color="primary"
      onClick={handleClick}
      label="Update Payment Status"
      className={className}
      isLoading={isLoading}
    />
  );
}

UpdatePaymentStatusButton.propTypes = {
  onUpdate: PropTypes.func,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
};

export default UpdatePaymentStatusButton;
